import { getSmartListsQuery as _getSmartListsQuery } from '@griply/services';
import { SmartList } from '@griply/types';
import {
  collection,
  CollectionReference,
  Firestore,
  orderBy,
  Query,
  query,
  QueryConstraint,
  where,
} from 'firebase/firestore';
import { ID } from 'shared/types/id';

import { smartListConverter } from './converters/smart-list';
import { getDatabase } from './helpers';

export const getSmartListsQuery = async (uid: ID) =>
  _getSmartListsQuery<
    CollectionReference,
    Query<SmartList>,
    QueryConstraint,
    Firestore
  >({
    db: getDatabase(),
    collection,
    query,
    where,
    orderBy,
    userId: uid,
  }).withConverter(smartListConverter);
